export const GRADIENTJ_API_KEY = "62d8d084474583b8429ddb2edcbbbf89be07e3cf";
